import React, { Component } from 'react';

import { ListItem } from 'material-ui/List';
import MenuItem from 'material-ui/MenuItem';

import LabelIcon from 'material-ui/svg-icons/action/label';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import * as Colors from 'material-ui/styles/colors';
import { statusColours } from '../../constants/ColourConstants';

import DeleteDialog from '../Common/DeleteDialog';
import LabelActions from '../../actions/LabelActionCreator';
import DialogActions from "../../actions/DialogActionCreator";
import { LabelDialogs } from '../../constants/Dialogs';


const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


class LabelListItem extends Component {

    render() {
        const { id, name } = this.props.data;
        return (
            <ListItem 
                style={style.listItem}
                leftAvatar={
                    <LabelIcon
                        style={style.icon}
                        color={statusColours.default}
                    />
                }
                primaryText={name}
                rightIcon={
                    <IconMenu
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton
                                touch={true}
                                style={style.iconButton}
                            >
                                <MoreVertIcon  color={Colors.grey400} />
                            </IconButton>
                        }
                    >
                        <MenuItem
                            primaryText="Edit"
                            leftIcon={<EditIcon />}
                            onClick={() => DialogActions.open(LabelDialogs.LABEL, {id, name, isEdit: true})}
                        />
                        <DeleteDialog
                            type="menu"
                            value={id}
                            title="Delete label"
                            onDelete={LabelActions.deleteLabel}
                            message={
                                <span>
                                    Are you sure to delete the Label  "{name}" ?
                                </span>
                            }
                        />
                    </IconMenu>
                }
            />
        )
    }
}

export default LabelListItem;
